import React from "react";
import Modal from "../elements/Modal";
import Button from "../form/Button";
import { useNavigate } from "react-router-dom";

function LogoutModal({ setIsOpen = () => {}, isOpen, redirectUrl = "/" }) {
  const navigate = useNavigate();
  return (
    <div>
      <Modal
        isOpen={isOpen}
        setIsOpen={(val) => setIsOpen(val)}
        size="lg"
        title={"Are you sure you want to exit?"}
        titleClass={"!text-primary"}
      >
        Your session will end. You'll need to log in again to continue.
        <div className="flex items-center  gap-4 pt-8 justify-center">
          <div>
            <Button
              buttonLabel={"Yes, I’m sure"}
              buttonLabelClasses={"!text-sm"}
              // buttonIcon={"fa-light fa-floppy-disk"}
              // buttonIconPosition={"left"}
              buttonClasses="!py-3 !px-4 rounded-lg text-white !h-auto !bg-primary hover:!bg-red-600 rounded-xl"
              buttonFunction={() => {
                localStorage.clear();
                sessionStorage.clear();
                window.location.href = window.location.origin + redirectUrl;
                setIsOpen(false);
              }}
            />
          </div>
          <div>
            <Button
              buttonLabel={"Cancel"}
              buttonLabelClasses={"!text-sm"}
              // buttonIcon={"fa-light fa-floppy-disk"}
              // buttonIconPosition={"left "}
              buttonClasses="rounded-xl bg-transparent !text-black border-primary border-2 hover:bg-transparent"
              buttonFunction={() => setIsOpen(false)}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default LogoutModal;
